<template>
    <div class="z-100">
        <div class="flex items-center space-x-2">
            <i class="fa fa-globe"
                :class="dark ? 'text-gray-500' : 'text-blue-400'"
            ></i>

            <select
                class="uppercase text-xs pl-1 py-0.5 rounded border"
                :class="dark ? 'border-gray-600 text-gray-300 bg-gray-600' : 'border-blue-400 text-blue-600 bg-blue-100'"
                v-model="current_language"
            >
                <option v-for="(language, i) in languages"
                    :key="`languages_${i}`"
                    :value="language"
                >
                    {{ language }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
import { availableLanguages, currentLanguage } from '../i18n';

export default {
    props: {
        dark: { default: false, },
    },

    data() {
        return {
            current_language: currentLanguage === 'en-ng' ? 'en' : currentLanguage,
            languages: availableLanguages,
        }
    },

    watch: {
        current_language(value) {
            axios.post('/locale/', {
                locale: value,
            }).then(response => {
                window.locale = value;
                window.location.reload();
            }).catch(error => {
                console.log(error.response);
            });
        },
    },
}
</script>
